/*
 Created by CHT 2019/10/10 16:51
 */
import BaseItem from '../BaseItem'
import {
	DATA_TYPE__STRING,
	FORM_ITEM__DESCRIPTION
} from "../types"

class Description extends BaseItem {
	constructor() {
		super()
		this.content = ''
	}

	get title() {
		return this.fieldTitle || Description._title
	}

	 set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

Description._title = '描述文字'
Description.type = FORM_ITEM__DESCRIPTION
Description.use = true
Description.icon = 'iconfont icon-describe'

Description.prototype.type = Description.type
Description.prototype.dataType = DATA_TYPE__STRING
Description.prototype.getConf = function () {
	const base = this.getBase()
	return {
		...base,
		content: this.content
	}
}
Description.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '等于任意一个',
    method: 'in'
  },
  {
    name: '不等于任意一个',
    method: 'nin'
  },
  {
    name: '包含',
    method: 'like'
  },
  {
    name: '不包含',
    method: 'unlike'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
Description.prototype.setConf = function (opts) {
	this.setBase(opts)
	if (opts.content) {
		this.content = opts.content
	}
}
Description.prototype.valueToString = function (value) {
	value = value || this.value
	return value
}
export default Description
